import React from "react";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import { Tooltip } from "react-tippy";
import { withRouter } from "react-router-dom";

import { Flex } from "../..";
import iconeLogoNome from "../../../_common/icones/exactclubicon.svg";

function ExactClub({ history }) {
  const redirecionarParaExactClub = () => {
    history.push("/spotter/exactclub");
  };
  return (
    <Flex alignItems="center" style={{ cursor: "pointer" }}>
      <Tooltip title="Exact Club">
        <Avatar
          onClick={redirecionarParaExactClub}
          aria-label="recipe"
          src={iconeLogoNome}
          style={{
            width: 110,
            height: 40,
            borderRadius: 8,
          }}
        />
      </Tooltip>
    </Flex>
  );
}

ExactClub.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withRouter(ExactClub);
